import { useContext } from 'react';
import { Props, Context } from './InitializerProvider';

const useInitializer = (): Props => useContext(Context);

export default useInitializer;
